import PropTypes from 'prop-types';
import React from 'react';
import Layout from '../../../components/Layout';

class Feedback extends React.Component {
  render() {
    return (
      <Layout>
        <div>
          {this.props.children}
        </div>
      </Layout>
    );
  }
}

export default Feedback;



// WEBPACK FOOTER //
// src/routes/feedback/components/Feedback.js